import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { QuotesManager, Security, BullBearStatements } from '@benzinga/quotes-manager';
import { SafeType } from '@benzinga/safe-await';

export const useBullsSayBearsSay = (symbol: Security): SafeType<BullBearStatements[]> | undefined => {
  const session = React.useContext(SessionContext);
  const quotesManager = session.getManager(QuotesManager);
  const [statements, setStatements] = React.useState<SafeType<BullBearStatements[]> | undefined>(undefined);

  React.useEffect(() => {
    setStatements(undefined);
    quotesManager.getBullSayBearSay([symbol]).then(statements => {
      setStatements(statements);
    });
  }, [quotesManager, symbol]);

  return statements;
};
